import { FeatureFlagsJSON } from '../types';

export default class FeatureFlags {
	readonly id: number;
	readonly watchFoldersEnabled: boolean;

	private constructor( json: FeatureFlagsJSON ) {
		this.id = json.id;
		this.watchFoldersEnabled = json.watch_folders_enabled;
	}

	static fromJson( json: FeatureFlagsJSON ): FeatureFlags {
		return new FeatureFlags( json );
	}
}
